// extracted by mini-css-extract-plugin
export default {"wrapper":"howitworks_wrapper__TFMJT","cardWrapper":"howitworks_cardWrapper__k-ncr","card":"howitworks_card__YmXDp"};